import { Project } from '@/lib/types'
import { Card, Badge } from '@/ui'

interface SummaryCardProps {
  project: Project
}

export function SummaryCard({ project }: SummaryCardProps) {
  return (
    <Card hover className="p-6">
      <div className="flex items-start justify-between mb-2">
        <h3 className="text-xl font-bold dark:text-gray-100">{project.title}</h3>
        <Badge variant={project.public ? 'success' : 'default'} size="sm">
          {project.public ? 'Public' : 'Private'}
        </Badge>
      </div>
      <p className="text-sm text-gray-500 mb-3 dark:text-gray-400">{project.type}</p>
      <p className="text-gray-700 mb-4 dark:text-gray-300">{project.one_liner}</p>

      {/* Outcomes */}
      {project.outcomes.length > 0 && (
        <div className="mb-4">
          <p className="text-sm font-semibold text-gray-600 mb-2 dark:text-gray-400">Outcomes:</p>
          <ul className="text-sm text-gray-700 space-y-1 dark:text-gray-300">
            {project.outcomes.slice(0, 2).map((outcome, i) => (
              <li key={i}>• {outcome}</li>
            ))}
          </ul>
        </div>
      )}

      {/* Tags */}
      <div className="flex flex-wrap gap-2">
        {project.tags.map((tag, i) => (
          <Badge key={i} variant="primary" size="sm">
            {tag}
          </Badge>
        ))}
      </div>
    </Card>
  )
}
